// @flow

import * as React from 'react';
import DataTable, {
  DataTableBody,
  DataTableCell,
  DataTableHead,
  DataTableRow,
} from 'sail/DataTable';
import {Heading} from 'docs/components';

import './DocsManifestTable.scss';

// TODO(matv): When we do not have two manifests and agree on the syntax, add typing and
// redo this file. I intentionally avoided doing that now since the docs proxy srv manifest is not 100% complete
// yet.

type DocRowProps = {|
  document: any,
|};

const DocRow = ({document}: DocRowProps) => {
  if (!document.route || document.route.includes('markdoc')) {
    return null;
  }
  return (
    <DataTableRow>
      <DataTableCell width={400}>
        <a href={document.route}>{document.public_metadata.title}</a>
      </DataTableCell>
      <DataTableCell>
        <a href={document.route}>{document.route}</a>
      </DataTableCell>
      <DataTableCell>
        <a href={`http://go/lgdocs/${document.path}`}>Livegrep</a>
      </DataTableCell>
    </DataTableRow>
  );
};

export const DocsManifestTable = ({manifest}: {manifest: any}) => {
  return (
    <DataTable className="DocsManifestTable" size="small">
      <DataTableHead
        columns={[{label: 'Title'}, {label: 'Route'}, {label: 'Livegrep'}]}
      />
      <DataTableBody>
        {manifest
          .filter((doc) => {
            return (
              doc.route &&
              doc.public_metadata &&
              doc.public_metadata.title &&
              !doc.route.includes('markdoc')
            );
          })
          .sort((a, b) => {
            return a.public_metadata.title.localeCompare(
              b.public_metadata.title,
            );
          })
          .map((doc) => (
            <DocRow key={doc.route} document={doc} />
          ))}
      </DataTableBody>
    </DataTable>
  );
};

export const DocsManifestTableByCondition = ({manifest}: {manifest: any}) => {
  const groupedByCondition = {};

  manifest
    .filter((doc) => {
      return doc.conditions && doc.route && doc.public_metadata.title;
    })
    .forEach((doc) => {
      doc.conditions.forEach((condition) => {
        groupedByCondition[condition] = groupedByCondition[condition] || [];
        groupedByCondition[condition].push(doc);
      });
    }, {});

  const rows = Object.keys(groupedByCondition)
    .sort()
    .map((condition) => {
      const docs = groupedByCondition[condition];
      return (
        <>
          <DataTableRow background="offset">
            <DataTableCell colSpan={3}>
              <Heading level={4} anchored id={condition}>
                {condition}
              </Heading>
            </DataTableCell>
          </DataTableRow>
          {docs.map((doc) => (
            <DocRow key={doc.route} document={doc} />
          ))}
        </>
      );
    });

  return (
    <DataTable className="DocsManifestTable" size="medium">
      <DataTableHead columns={[{label: 'Condition', colSpan: 3}]} />
      <DataTableBody>{rows}</DataTableBody>
    </DataTable>
  );
};
